import router from './router'
import store from './store'
import NProgress from 'nprogress'
import { Message } from 'element-ui'
import { getToken } from '@utils/auth'
const whiteList = [
  '/login',
  '/bindAccount',
  '/404',
  '/register',
  '/createuser',
  '/register-result',
] // 不重定向白名单

router.beforeEach((to, from, next) => {
  console.log('to', to, from, new Date().getTime())
  NProgress.start() // 开启Progress

  if (getToken()) {
    // && !to.fullPath.includes('account')
    // 判断是否有token
    if (to.path === '/login') {
      console.log(store.getters['permission/permissionList'])

      store.getters['permission/permissionList'].length > 0
        ? next({
            path: store.getters['permission/permissionList'][0].path,
          })
        : next()

      NProgress.done()
    } else {
      console.log(store.getters['user/role'], 'role')
      if (!store.getters['user/role']) {
        // 判断当前用户是否已拉取完user_info信息
        console.log('拉取用户信息')
        ;(async () => {
          try {
            const res = await store.dispatch('user/GetInfo') // 执行GetInfo方法
            const role = res.role
            console.log(res, 'res userinfo')
            // 通过输入当前用户角色,得到路由表

            await store.dispatch('permission/GetRouterList', role)

            console.log(
              store.getters['permission/permissionList'],
              '许可地址',
              to.path,
              to,
              from,
              '目的地址'
            )
            console.log(
              store.getters['permission/permissionList'].map(item => item.path),
              to.path,
              '有木有'
            )
            router.addRoutes(store.getters['permission/permissionList'])

            if (
              store.getters['permission/permissionList']
                .map(item => item.path)
                .includes(to.path)
            ) {
              next(to.fullPath)
            } else {
              console.log(
                store.getters['permission/permissionList'][0].path,
                '没有则'
              )
              next({
                // path: store.getters['permission/permissionList'][0].path,
                // path: from.fullPath,
              })
            }
          } catch (error) {
            await store.dispatch('user/FeLogout')
            Message.error('验证失败,请重新登录')
            next({ path: '/login' })
          }
        })()
      } else {
        console.log('to', to.fullPath, from.fullPath, '有权限')
        next()
      }
    }
  } else {
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next({ path: '/login' })
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})
